import './AffiliatePanel.scss';
import React, { useEffect, useState } from 'react';
import AffiliatesCRUDActions from '@mm/state/actions/AffiliatesCRUDActions';
import { useDispatch } from 'react-redux';
import {
  CopyOutlined,
  GiftOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import { SettingsSectionHeader } from '../common/SettingsSectionHeader/SettingsSectionHeader';
import { PrimaryButton } from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import CopyToClipboard from 'react-copy-to-clipboard';
import { notification, Tooltip } from 'antd';

const AffiliatePanel = () => {
  const [fetchComplete, setFetchComplete] = useState(false);

  const affiliateLoginURL = `${PAP_HOST}affiliates/login.php#login`;

  const dispatch = useDispatch();

  const fetchAffiliateForCurrentUser = () =>
    dispatch(AffiliatesCRUDActions.fetchForCurrentUser());

  const fetchOnMount = async () => {
    await fetchAffiliateForCurrentUser();

    setFetchComplete(true);
  };

  useEffect(() => {
    fetchOnMount();
  }, []);

  if (!fetchComplete) {
    return null;
  }

  return (
    <SettingsSectionHeader
      title="Referrals"
      color="#EB2F96"
      icon={<GiftOutlined />}
      headerComponent={
        <div className="affiliate-panel__header-buttons">
          <CopyToClipboard
            text={affiliateLoginURL}
            onCopy={() =>
              notification.success({
                message: `The link is copied`,
              })
            }
          >
            <PrimaryButton className="affiliate-panel__button">
              <CopyOutlined />
              Copy link
            </PrimaryButton>
          </CopyToClipboard>
          <Tooltip
            color="white"
            overlayInnerStyle={{
              color: '#262626',
              padding: '8px 16px',
              fontFamily: 'Roboto',
            }}
            placement="bottomLeft"
            title="Please copy PostAffiliatePro link and paste it in the new browser’s
            tab."
          >
            <QuestionCircleOutlined className="affiliate-panel__question-icon" />
          </Tooltip>
        </div>
      }
    >
      <div className="affiliate-panel__description">
        <div style={{ fontWeight: 500 }}>
          Customer.ai has partnered with PostAffiliatePro to bring you the best
          affiliate experience possible!
        </div>
        <div>
          Join us at the{' '}
          <span
            onClick={() => {
              window.open('https://customers.ai/blog');
            }}
            className="affiliate-panel__link"
          >
            Affiliate Blog
          </span>{' '}
          for great resources, tips, and tricks on how to promote Customers.ai
          to your network.
        </div>
        <div>
          Contact{' '}
          <a
            href="mailto:affiliate@customers.ai"
            target="_blank"
            rel="noopener noreferrer"
            className="affiliate-panel__link"
          >
            affiliate@customers.ai
          </a>{' '}
          with any questions.
        </div>
      </div>
    </SettingsSectionHeader>
  );
};

export default AffiliatePanel;
